const setTableHeaderClass = () => {
	const harmonyTable = document.getElementById('harmony-table');
	if(harmonyTable) {
		document.addEventListener('scroll', e => {
			let offset = harmonyTable.getBoundingClientRect().top;
			if (offset <= 0) {
				harmonyTable.classList.add('pinned-header');
			} else {
				harmonyTable.classList.remove('pinned-header');
			}
		})
	}
};

if (
	document.readyState === "complete" ||
	(document.readyState !== "loading" && !document.documentElement.doScroll)
) {
	setTableHeaderClass();
} else {
	document.addEventListener("DOMContentLoaded", setTableHeaderClass);
}